<template>
  <form class="page-mutate-theme" @submit.prevent="$emit('submit')">
    <Card class="page-mutate-theme__inputs">
      <Alert v-if="isCustomTheme" class="page-mutate-theme__custom" data-field="themes">{{
        $t('customThemeActiveMessage')
      }}</Alert>

      <div v-else data-field="themes" class="mb-2">
        <div class="template-section-intro">
          <h2>{{ $t('selectTheme') }}</h2>
          <span>{{ $t('pageThemeHelper') }}</span>
        </div>
        <div class="page-mutate-theme__items">
          <ThemeCard
            v-for="theme in themes"
            :key="'theme_' + theme.value"
            :value="theme"
            :active="theme.value === value.theme.template"
            @select="value.theme.template = theme.value"
          />
        </div>
      </div>
      <FieldRenderer v-for="item in fields.default" :item="item" :value="value" />

      <CustomFields
        v-model="value.customFields"
        :schema="customFieldSchemas"
        :data="value"
        :placement="['theme', 'page:theme']"
        data-field="custom-fields"
        :validator="validator"
        validator-prefix="customFields"
        :disabledFields="$path('metadata.disabledFields.page', item)"
      >
        <template v-for="item in fields.slots" v-slot:[item.slotKey]>
          <FieldRenderer :item="item" :value="value" /> </template
      ></CustomFields>
    </Card>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import { i18n } from '@/i18n'

import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import { CheckboxComponent } from 'vue-elder-checkbox'
import { AlertComponent as Alert } from 'vue-elder-alert'
import Upsell from '@/components/Upsell/Trigger'
import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/Page/StepsFields/FieldRenderer.vue'
import ThemeCard from '@/components/Project/ThemeCard.vue'

const meta = {
  order: 2,
  id: 'theme',
  label: i18n.t('designAndTheme'),
  icon: ['fal', 'palette'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      themes(state) {
        return (state.enums.Themes || []).filter(({ type }) => type === 'page')
      },
    }),
    ...mapState('Page', ['item']),
    ...mapState(['enums']),
    isCustomTheme() {
      if (!this.value.theme.template) return false
      return !this.currentTheme
    },
    currentTheme() {
      return this.themes.find(t => t.value === this.value.theme.template)
    },
  },
  components: {
    Card,
    InputComponent,
    Alert,
    Upsell,
    CustomFields,
    ThemeCard,
    CheckboxComponent,
    FieldRenderer,
  },
}
</script>

<style lang="scss">
.page-mutate-theme {
  $cols: 2;

  &__items {
    grid-column-end: span 2;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2rem;
    margin-bottom: 2rem;
    margin-top: 1rem;

    .theme-card--shrink.theme-card {
      .link-card {
        &__image {
          aspect-ratio: 4/2;
          border-radius: inherit;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          img {
            transform: translate(0, 20px);
          }
        }

        &__content {
          padding: 1rem;
          h3 {
            margin: 0;
          }
        }
      }
    }
  }

  &__inputs {
    max-width: 900px;
    margin: auto;

    .card__content {
      display: grid;
      grid-template-columns: repeat($cols, 1fr);
      grid-gap: 1rem;
      align-items: baseline;
      [data-field='themes'] {
        grid-column-end: span 2;
      }
    }
  }

  &__preview {
    font-size: 0.8em;
  }

  .custom-fields {
    grid-column-end: span $cols;
  }
}
</style>
